"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function is(obj, type) {
    if (obj === null || obj === undefined) {
        return obj === type;
    }
    return obj.constructor === type;
}
exports.is = is;

//# sourceMappingURL=instanceOf.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/uribuilder/instanceOf.js
// module id = ./node_modules/uribuilder/instanceOf.js
// module chunks = vendor